import React, { useState } from "react";
import { Typography, Tooltip, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { isEmpty } from "lodash";
import axios from "axios";
import {API_URL} from "../constant"
import LoadingSpinner from "./LoadingSpinner";
import { useSnackbar } from "notistack";


const FileStatus = ({ label, fileType, downloadUrl, details, onSuccess, onError }) => {
  const isFileAvailable = !isEmpty(downloadUrl);
    const [loading, setLoading] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

  // Handle File Download
  const handleDownload = () => {
    window.open(downloadUrl, "_blank");
  };

  // Handle File Upload
 const handleUpload = async (event) => {
  try {
    setLoading(true)
    const files = event.target.files;
    if (!files || files.length === 0) return;

    let formData = new FormData();
    for (let file of files) {
      formData.append("documents", file);
    }

    const data = { ...details, doc_type: fileType, type: fileType };
    formData.append("data", JSON.stringify(data));

    // API call
    const response = await axios.post(`${API_URL}/lead/update/${details.loan_id}`, formData);

    if (response?.data?.status === "success") {
      onSuccess?.();
      enqueueSnackbar(`${fileType} - File Upload successfully `, { variant: 'success' });
    }

  } catch (error) {
    let message = "File upload failed. Please try again.";

    if (error.response) {
      const status = error.response.status;
      const errorData = error.response.data;

      //Extract readable error message from backend
      message =
        errorData?.error?.message ||
        errorData?.message ||
        errorData?.error ||
        `Upload failed with status ${status}`;

      //Clean up newlines and spacing
      message = message.replace(/\n/g, " ").trim();
    } else if (error.request) {
      message = "No response received from server.";
    } else {
      message = error.message || "Unexpected error occurred.";
    }

    enqueueSnackbar(`${fileType} - File upload failed. Please try again`, { variant: 'error' });

    // Show user-friendly message
    alert(`${message}`);
  } finally {
    setLoading(false)
  }
};


  return (
    <Typography
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      width={220}
      border={1}
      borderColor="divider"
      borderRadius={1}
      padding="8px 12px"
      sx={{
        "& button": {
          minWidth: "auto",
          padding: "4px",
        },
      }}
    >
      <Tooltip title={isFileAvailable ? "Download File" : "Upload File"}>
        {isFileAvailable ? (
          <Button onClick={handleDownload}>
            <FileDownloadIcon color="primary" />
          </Button>
        ) : (
          <Button component="label">
            <FileUploadIcon color="secondary" />
            <input type="file" hidden onChange={handleUpload} />
          </Button>
        )}
      </Tooltip>
      <Typography variant="body2" noWrap>
        {label}
      </Typography>
      {loading && <LoadingSpinner  message={'Uploading and Extracting File ...'}/>}
    </Typography>
  );
};

export default FileStatus;
